export default {
  // Navigation
  'nav.timer': 'टाइमर',
  'nav.stopwatch': 'स्टॉपवॉच',
  'nav.worldclock': 'विश्व घड़ी',
  'nav.timestamp': 'टाइमस्टैम्प',
  'nav.home': 'होम',

  // Common buttons and actions
  'button.start': 'शुरू करें',
  'button.pause': 'रोकें',
  'button.stop': 'बंद करें',
  'button.reset': 'रीसेट करें',
  'button.ok': 'ठीक है',
  'button.cancel': 'रद्द करें',
  'button.close': 'बंद करें',
  'button.save': 'सहेजें',
  'button.delete': 'हटाएं',
  'button.edit': 'संपादित करें',
  'button.back': 'वापस',
  'button.next': 'अगला',
  'button.previous': 'पिछला',
  'button.submit': 'सबमिट करें',
  'button.confirm': 'पुष्टि करें',
  'button.convert': 'कन्वर्ट करें',
  'button.copy': 'कॉपी करें',
  'button.copied': 'कॉपी हो गया!',
  'button.now': 'अभी',
  'button.clear': 'साफ़ करें',

  // Common labels
  'label.hours': 'घंटे',
  'label.minutes': 'मिनट',
  'label.seconds': 'सेकंड',
  'label.milliseconds': 'मिलीसेकंड',
  'label.minute': 'मिनट',
  'label.second': 'सेकंड',
  'label.sound': 'ध्वनि',
  'label.soundAlert': 'ध्वनि',
  'label.fullscreen': 'पूर्ण स्क्रीन',
  'label.language': 'भाषा',
  'label.selectLanguage': 'भाषा चुनें',
  'label.languageSelectorInfo': 'वर्तमान में {{count}} भाषाओं का समर्थन करता है। ऊपर दिए गए विकल्पों में से अपनी पसंदीदा भाषा चुनें।',

  // Common messages
  'message.timerComplete': 'टाइमर पूरा हुआ!',
  'message.timerCompleteDesc': 'आपका टाइमर समाप्त हो गया है',
  'message.timerCompleteBody': 'आपका काउंटडाउन टाइमर समाप्त हो गया है!',
  'message.stopwatchStarted': 'स्टॉपवॉच शुरू हुआ',
  'message.stopwatchStartedDesc': 'स्टॉपवॉच टाइमिंग शुरू हो गई है',
  'message.stopwatchStopped': 'स्टॉपवॉच रुका',
  'message.stopwatchStoppedDesc': 'स्टॉपवॉच टाइमिंग को रोक दिया गया है',
  'message.stopwatchReset': 'स्टॉपवॉच रीसेट हुआ',
  'message.stopwatchResetDesc': 'स्टॉपवॉच को शून्य पर रीसेट कर दिया गया है',
  'message.notificationPermission': 'टाइमर समाप्त होने पर सूचनाएं प्राप्त करने के लिए अनुमति दें',
  'message.clickToEdit': 'समय सीधे संपादित करने के लिए समय संख्याओं पर क्लिक करें',
  'message.addHours': '+ घंटे जोड़ें',
  'message.escToExit': 'पूर्ण स्क्रीन से बाहर निकलने के लिए ESC दबाएं',
  'message.timeRemaining': '{{minutes}} मिनट {{seconds}} सेकंड शेष',
  'message.minutesRemaining': '{{minutes}} मिनट शेष',
  'message.secondsRemaining': '{{seconds}} सेकंड शेष',
  'message.stopwatchTimeElapsed': '{{minutes}} मिनट {{seconds}} सेकंड बीत गए',
  'message.stopwatchMinutesElapsed': '{{minutes}} मिनट बीत गए',
  'message.stopwatchSecondsElapsed': '{{seconds}} सेकंड बीत गए',
  'message.invalidTimestamp': 'अमान्य टाइमस्टैम्प',
  'message.invalidDateTime': 'अमान्य तारीख समय',
  'message.conversionError': 'रूपांतरण त्रुटि',

  // Time units
  'time.am': 'पूर्वाह्न',
  'time.pm': 'अपराह्न',
  'time.now': 'अभी',
  'time.today': 'आज',
  'time.yesterday': 'कल',
  'time.tomorrow': 'कल',

  // Common errors
  'error.pageNotFound': 'पेज नहीं मिला',
  'error.somethingWrong': 'कुछ गलत हो गया',
  'error.tryAgain': 'कृपया बाद में पुनः प्रयास करें',

  // Footer
  'footer.about': 'timer.today के बारे में',
  'footer.aboutDesc': 'timer.today एक पेशेवर ऑनलाइन टाइमिंग टूल प्लेटफॉर्म है जो तीन मुख्य सुविधाएं प्रदान करता है:',
  'footer.timerDesc': 'अनुकूलन योग्य काउंटडाउन टूल जो मिनट और घंटे की सेटिंग्स का समर्थन करता है, काम पर ध्यान केंद्रित करने, खाना पकाने के समय, अध्ययन प्रबंधन और अधिक के लिए एकदम सही। ध्वनि अलर्ट और डेस्कटॉप सूचनाएं शामिल हैं।',
  'footer.stopwatchDesc': 'मिलीसेकंड सटीकता के साथ उच्च-सटीक टाइमिंग टूल, खेल प्रशिक्षण, खाना पकाने के संचालन, परीक्षा अभ्यास और अन्य परिदृश्यों के लिए उपयुक्त जहां सटीक समय की आवश्यकता होती है।',
  'footer.worldClockDesc': 'दुनिया भर के प्रमुख शहरों के समय का वास्तविक समय प्रदर्शन बुद्धिमान समय क्षेत्र गणना के साथ, अंतर्राष्ट्रीय व्यापार संचार और क्रॉस-टाइमज़ोन सहयोग की सुविधा प्रदान करता है।',
  'footer.timestampDesc': 'Unix टाइमस्टैम्प कनवर्टर टाइमस्टैम्प और डेटाटाइम के बीच द्विदिशात्मक रूपांतरण का समर्थन करता है, सेकंड और मिलीसेकंड दोनों प्रारूप समर्थन के साथ।',
  'footer.termsOfService': 'सेवा की शर्तें',
  'footer.privacy': 'गोपनीयता',
  'footer.contactUs': 'संपर्क करें',
  'footer.changeLanguage': 'भाषा बदलें',
  'footer.moreLanguage': 'अधिक भाषाएं',
  'footer.copyright': '© timer.today 2024',

  // Quick actions
  'quick.add30s': '+30 से.',
  'quick.add1min': '+1 मिनट',
  'quick.add5min': '+5 मिनट',
  'quick.add10min': '+10 मिनट',
  'quick.add30min': '+30 मिनट',

  // Breadcrumb
  'breadcrumb.minuteTimer': '{{minutes}} मिनट टाइमर',
  'breadcrumb.timer': 'टाइमर',
  'breadcrumb.stopwatch': 'स्टॉपवॉच',
  'breadcrumb.worldClock': 'विश्व घड़ी',
  'breadcrumb.termsOfService': 'सेवा की शर्तें',
};
